import React from "react"
import { Box, Flex, FlexProps } from "@chakra-ui/core"
import { FluidObject } from "gatsby-image"
import { placeholderImage } from "../../utils"
import useVariantHandler from "../../hooks/useVariantHandler"
import {
  ContentfulBicycleModel,
  ContentfulProduct,
} from "../../../graphql-types"
import FormattedTitle from "../FormattedTitle"
import DropDownSelector from "../DropDownSelector"
import Heading from "../typography/Heading"
import { Button } from "../Buttons"
import { Link } from "gatsby"
import BackgroundImage from "../BackgroundImage"
import { BikeVariant } from "../BikeProductCard"

type CompareColumnHeaderProps = FlexProps & {
  bike: ContentfulBicycleModel
  variant: BikeVariant
  defaultSpeed?: string
  onSpeedChange?: (speed: string) => void
}

export default function CompareColumnHeader({
  bike,
  defaultSpeed,
  variant,
  onSpeedChange,
  ...props
}: CompareColumnHeaderProps) {
  const speeds: ContentfulProduct[] = Object.values(
    (bike.speeds || []).reduce((acc, speed) => {
      if (speed?.speed) {
        acc[speed?.speed] = speed
      }
      return acc
    }, {})
  )

  const {
    currentVariant,
    speed: currentSpeed,
    onSpeedChange: handleSpeedChange,
  } = useVariantHandler({
    speeds: speeds,
    defaultValue: { speed: defaultSpeed },
  })

  return (
    <Flex
      w="100%"
      flexDir="column"
      justifyContent="flex-start"
      alignItems="stretch"
      {...props}
    >
      <BackgroundImage
        // w="57.75%"
        w="100%"
        h="12.5rem"
        mx="auto"
        mt="3.625rem"
        backgroundPosition="top"
        backgroundSize="contain"
        flexGrow={0}
        flexShrink={0}
        fluid={
          (currentVariant?.productListingImage?.fluid ||
            placeholderImage) as FluidObject
        }
      />
      <Flex
        px="2rem"
        justify="space-between"
        flexDir={["column", null, null, null, null, null, "row"]}
        flexGrow={1}
      >
        <Box mr="1rem">
          <Heading as="span" size="5" mb="0.25rem">
            <FormattedTitle raw={bike.formattedTitle} whiteSpace="pre" />
          </Heading>
          <Flex pos="relative">
            <DropDownSelector
              title="speed"
              options={
                speeds
                  ?.sort((a, b) =>
                    Number(a?.speed || "0") > Number(b?.speed || "0") ? 1 : -1
                  )
                  ?.map((speed) => ({
                    title: `${speed?.speed} speed`,
                    name: speed?.speed || "",
                    selected: speed?.speed === currentSpeed,
                  })) || []
              }
              dropDownType="single"
              onOptionSelected={(speed) => {
                onSpeedChange?.(speed)
                handleSpeedChange(speed)
              }}
              showChevron
              left="-1rem"
            />
          </Flex>
        </Box>
        <Link
          to={`/products/${bike.internalTitle}?variant=${variant.uniqueId}`}
        >
          <Button
            h="3.5rem"
            w={["100%", null, null, null, null, null, "7.5rem"]}
            mt={["0.25rem", null, null, null, null, null, "0"]}
            px="0"
            whiteSpace="nowrap"
          >
            View
          </Button>
        </Link>
      </Flex>
    </Flex>
  )
}
